export const convertToTwoDecimal = (num: number) => {
    if (!num) return 0.00
    let formattedNum = num.toFixed(2);
    if (!Number.isInteger(num)) {
        let parts = formattedNum.split(".");
        if (parts.length === 1) {
            formattedNum += "0";
        }
    }
    return formattedNum;
}